module.exports = __webpack_public_path__ + "media/images/university_logos/Canterbury-University-e469ee9e20fcae9e87d3a106a498f953.svg";